import { toTitleCase } from "../../../../Utils/stringUtls"; 
import { I2cIcon } from "@webcomponents/i2cwebcomponents/dist/react";
import { features, otpDeliveryMethods, yellowPathOtp, liveAgent } from "../../OptionalFeatures/stringUtils";
import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import ReviewSummarySectionHeading from "../../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";

const DigitalWalletsOverview = ({ data }) => {
  const {
    of_dw_mobile_wallets,
    of_dw_mobile_wallet_other,
    of_dw_card_holders,
    of_dw_live_agent,
    of_dw_live_agent_other,
    of_dw_email_authentication,
    of_dw_email_authentication_other,
    of_dw_otp_delivery,
    of_dw_provisioning_process,
    of_dw_i2c_mobile_app_host,
    of_dw_service_enable_via,
  } = data["2_2"];

  const yellowPathValue = of_dw_card_holders?.length
    ? yellowPathOtp
        .filter((holder) => of_dw_card_holders.includes(holder.value))
        .map((holder) => holder.label)
        .join(", ")
    : null;

  const otpDeliveryValue = of_dw_otp_delivery?.length
    ? otpDeliveryMethods
        .filter((source) => of_dw_otp_delivery.includes(source.value))
        .map((source) => source.label)
        .join(", ")
    : null;

  const liveAgentValue =
    of_dw_live_agent === "other"
      ? toTitleCase(of_dw_live_agent_other ?? "")
      : liveAgent.find((agent) => agent.value === of_dw_live_agent)?.label;

  const emailAuthValue =
    of_dw_email_authentication === "other"
      ? toTitleCase(of_dw_email_authentication_other ?? "")
      : liveAgent.find((agent) => agent.value === of_dw_live_agent)?.label;

  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid" className="review-summary-gap">
        <div i2c-grid="12@md">
          <ReviewSummarySectionHeading title="Digital Wallets" />
        </div>

        <div i2c-grid="12@md">
          <div className="review-summary-section-heading mb-8">Mobile Wallets</div>
          <div className="overview-val-text mobile-wallets-container">
            {of_dw_mobile_wallets?.length
              ? features.map((wallet, index) =>
                  of_dw_mobile_wallets?.includes(wallet.value) ? (
                    <span className="mobile-wallet-item" key={index}>
                      <I2cIcon src={wallet.icon} className="mobile-wallet-icon" />
                      <span>
                        {wallet.value === "others"
                          ? toTitleCase(of_dw_mobile_wallet_other)
                          : wallet.label}
                      </span>
                    </span>
                  ) : (
                    ""
                  )
                )
              : "-"}
          </div>
        </div>

        <div i2c-grid="12@md">
          <div className="review-summary-section-heading">
            Authentication for Yellow Path cardholders
          </div>
        </div>

        <ReviewAttribute
          label="For Yellow Path (cardholders failing enrollment), please confirm what alternate methods for Cardholder Authentication will be used"
          value={yellowPathValue}
        />

        {of_dw_card_holders?.includes("live-agent") && (
          <ReviewAttribute
            label='If opting for "Live Agent", please confirm who will provide the contact center service for Live Agent support for cardholders'
            value={liveAgentValue || null}
          />
        )}
        {of_dw_card_holders?.includes("via-email") && (
          <ReviewAttribute
            label='If opting for "E-mail", please confirm who will manage'
            value={emailAuthValue || null}
          />
        )}

        <div i2c-grid="12@md">
          <div className="review-summary-section-heading mb-4">OTP Delivery</div>
        </div>

        <ReviewAttribute
          label="Please confirm how would you like the OTP to be delivered to cardholders"
          value={otpDeliveryValue}
        />

        <div i2c-grid="12@md">
          <div className="review-summary-section-heading mb-4">
            Digital Wallet Provisioning Process
          </div>
        </div>

        <ReviewAttribute
          label="Would you like to enable In-App Provisioning (Push Provisioning) with Digital Wallets?"
          value={of_dw_provisioning_process?.length ? toTitleCase(of_dw_provisioning_process) : null}
        />

        <ReviewAttribute
          label="Will the mobile app be hosted by i2c Inc.?"
          value={of_dw_i2c_mobile_app_host?.length ? toTitleCase(of_dw_i2c_mobile_app_host) : null}
        />

        {of_dw_i2c_mobile_app_host === "no" ? (
          <ReviewAttribute
            label="If you are not taking i2c hosted mobile app, would you like to enable this service via"
            value={of_dw_service_enable_via?.length ? toTitleCase(of_dw_service_enable_via) : null}
          />
        ) : null}
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};
export default DigitalWalletsOverview;
